import { MapType } from '@/types';

export const WEBENGAGE_EVENTS = {
  PAGE_VIEWED: 'Page Viewed',
  BUY_AMC_CLICKED: 'Buy AMC Clicked',
};

export const BANK_OFFER_PRICE_THRESHOLD = 5000;

export const COUPON = {
  MIN_COUPON_CHARACTERS: 4,
  MIN_COUPON_OTP_CHARACTERS: 6,
  MAX_COUPON_OTP_CHARACTERS: 6,
  MAX_COUPONS_ALLOWED: 3,
};

export const ECOM_DEFAULT_QUANTITY = {
  min: 1,
  max: 5,
};

export const ERROR = {
  GENERIC_MESSAGE: 'Something went wrong',
  NOT_FOUND_DESC: 'Oops! We cannot seem to get you to the page you are looking for.',
};
export const ECOM_HOME_URL = '/';
export const LOGIN_URL = '/login';
export const AMC_DEVICE_PAGE_URL = '/amc/my-devices';
export const ECOM_CART_URL = '/ecom/cart';
export const ECOM_CHECKOUT_URL = '/ecom/checkout';
export const ECOM_CC_AGENT = '/amc/cc/agent';
export const ECOM_CRO_AGENT = '/amc/cro/agent';
export const PUBLIC_URLS = [
  ECOM_CC_AGENT,
  ECOM_CRO_AGENT,
  '/customer-service-and-amc',
  LOGIN_URL,
  ECOM_CART_URL,
];
export const SCA_COOKIE = 'efl_sca';
export const TERMS_AND_CONDITIONS_URL = '/amc-new-terms-and-condition';
export const NCEMI_TERMS_AND_CONDITIONS_URL = '/ncemi_tnc_amc';
export const ENV_VARS_LOCAL_STORAGE_KEY = 'env';
export const PROFILE_TAB_URL = '/customer/account/index';
export const MY_ORDERS_TAB_URL = '/subscription/order/history';
export const AMC_TAB_URL = AMC_DEVICE_PAGE_URL;
export const MY_COUPON_TAB_URL = '/easyrewardz/index/couponlist';
export const MY_SERVICES_TAB_URL = '/service';
export const MY_DEVICES_TAB_URL = AMC_DEVICE_PAGE_URL;
export const MAGENTO_AMC_URL = AMC_DEVICE_PAGE_URL;
export const STATUS_TRACKING_URL = '/statusTracking';
export const DEVICE_DETAIL_PAGE = '/amc/my-device';

export const RAZORPAY_TIMEOUT = 720;

export const AUTHENTICATED_ROUTES = [AMC_DEVICE_PAGE_URL];

export const SELLER_URLS = {
  STORE: '/seller/store',
  DASHBOARD: '/seller/dashboard',
  LOGIN: '/seller/login',
  EARNINGS: '/seller/earnings',
  WELCOME: '/seller/welcome',
  TRAINING: '/seller/training',
  CATEGORY: '/seller/c/',
  PDP: '/seller/dp/',
  ORDERS: '/seller/orders',
  SEARCH: '/seller/search',
  ANALYTICS: '/seller/analytics',
  PAYOUT_HISTORY: '/seller/payout/history',
};

export const AUTHENTICATED_ROUTES_STARTS_WITH = [
  '/amc-plans/',
  '/amc-service-plans',
  '/payment',
  '/rateProfessional',
  '/service',
  '/statusTracking',
  '/cart',
  '/ecom/checkout',
  // '/ecom/payment/', // ["/ecom/payment/success","/ecom/payment/failed"]
  '/ecom/order', // ["/ecom/orders","/ecom/order/order-id","/ecom/order/order-id/detail"]
  '/account/',
  '/freeservice',
  SELLER_URLS.STORE,
  SELLER_URLS.DASHBOARD,
  SELLER_URLS.EARNINGS,
  SELLER_URLS.TRAINING,
  SELLER_URLS.ORDERS,
  SELLER_URLS.PDP,
  SELLER_URLS.CATEGORY,
  SELLER_URLS.SEARCH,
  SELLER_URLS.WELCOME,
];

export const ADDITIONAL_PLANS: MapType = {
  EXTENDED_WARRANTY: 'ES',
};

export const SC_CODE = 'scCode';
